import { z } from 'zod';

import { BaseToolResultSchema } from './baseResult';

export const GenerateTextArgsSchema = z.object({
  font: z.unknown().describe('Font configuration'),
  fontColor: z.string().optional().default('#000000').describe('Text color as hex string (default: #000000)'),
  fontSize: z.number().describe('Font size in pixels'),
  height: z.number().optional().describe('Bounding box height in pixels'),
  image: z.string().optional().describe('Image reference this text is associated with ([media:nodeId])'),
  letterSpacing: z.number().optional().describe('Letter spacing in pixels'),
  lineHeight: z.number().optional().describe('Line height multiplier'),
  positionX: z.number().optional().default(0).describe('X position on the canvas (default: 0)'),
  positionY: z.number().optional().default(0).describe('Y position on the canvas (default: 0)'),
  text: z.string().describe('The text content to place on the canvas'),
  textAlign: z
    .enum(['left', 'center', 'right'])
    .optional()
    .default('center')
    .describe('Horizontal text alignment (default: center)'),
  width: z.number().optional().describe('Bounding box width in pixels'),
});

export type GenerateTextArgs = z.infer<typeof GenerateTextArgsSchema>;

export const GenerateTextResultSchema = BaseToolResultSchema.extend({
  fontFileUrl: z.string().optional(),
  fontMetadataUrl: z.string().optional(),
  fontSource: z.enum(['builtIn', 'file']),
  height: z.number(),
  image: z.string().optional(),
  message: z.string(),
  positionX: z.number(),
  positionY: z.number(),
  textNode: z.object({
    fontColor: z.string(),
    fontFamily: z.string(),
    fontSize: z.number(),
    fontVariant: z.string().optional(),
    letterSpacing: z.number().optional(),
    lineHeight: z.number().optional(),
    text: z.string(),
    textAlign: z.enum(['left', 'center', 'right']),
  }),
  width: z.number(),
});

export type GenerateTextResult = z.infer<typeof GenerateTextResultSchema>;

export const GENERATE_TEXT_TOOL_NAME = 'generate_text';

export const GENERATE_TEXT_TOOL_DESCRIPTION = 'Generate styled text with specified font, size, color, and alignment.';

export const GENERATE_TEXT_TOOL = {
  description: GENERATE_TEXT_TOOL_DESCRIPTION,
  name: GENERATE_TEXT_TOOL_NAME,
  parameters: GenerateTextArgsSchema.toJSONSchema(),
};
